import { nfp } from 'components/MainComponent/textBuilder'
import styled from 'styled-components'

export const ColumnChart = ({
  data,
  userSingle,
  lang
}: {
  data: FlowColumData[]
  userSingle?: string
  lang: 'de' | 'fr' | undefined
}) => {
  console.log(data)
  if (data.length === 0) return null

  const maxData = data.reduce(
    (max, p) => (p.valueInPercent > max ? p.valueInPercent : max),
    data[0].valueInPercent
  )
  const sumData = data.reduce((sum, p) => sum + p.value, 0)

  const dict: { [key: string]: string } = {
    'Café Crème': 'Café noir',
    Espresso: 'Expresso',
    Cappuccino: 'Cappuccino',
    'Latte Macchiato': 'Latte macchiato',
    Schale: 'Café au lait',
    Filterkaffee: 'Café filtre',
    Ristretto: 'Ristretto',
    'Flat White': 'Flat White'
  }

  return (
    <FlowColumnsRoot>
      {data &&
        data
          .sort((a, b) => b.valueInPercent - a.valueInPercent)
          .map((item, i) => {
            const { id, label, value, valueInPercent, abbr } = item

            const barPercent = (valueInPercent * 100) / maxData

            return (
              <DrinkRow className='row' key={'drinkrow' + i}>
                <Icon>
                  <img src={require('../../assets/icons_' + id + '.png')} />
                </Icon>
                <Label>{lang === 'de' ? label : dict[label]}</Label>
                <BarContainer>
                  <Bar
                    style={{
                      width: barPercent + '%'
                    }}
                  />{' '}
                  {valueInPercent}%
                </BarContainer>
                <Stats>
                  <span className='value'>
                    {value > 9999
                      ? nfp(value).toString().replace('.', "'")
                      : value}
                  </span>{' '}
                </Stats>
              </DrinkRow>
            )
          })}
      {/* <DrinkRow className='row total'>
        <Icon></Icon>
        <Label className='label'>Total</Label>
        <Stats>
          <span className='value'>
            {nfp(sumData).toString().replace('.', "'")}
          </span>
          {100}%
        </Stats>
      </DrinkRow> */}
    </FlowColumnsRoot>
  )
}
const DrinkRow = styled.div`
  width: 100%;
  display: flex;

  font-size: 15px;
  padding: 0;
  flex: 0 0 100%;
  /* padding-right: 10px; */
  height: 50px;
  border-bottom: 1px solid var(--coffee-dark);
  &.total {
    color: var(--coffee-light);
    border: 0;
    .label {
      justify-content: flex-start;
      @media screen and (max-width: 711px) {
        justify-content: flex-end;
      }
    }
  }
  @media screen and (max-width: 711px) {
    flex-wrap: wrap;
    height: unset;
  }
`
const BarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: var(--font-sans-serif);
  font-size: 12px;
  line-height: 1em;
  flex: 0 0 40%;
  margin-top: 5px;
  margin-bottom: 5px;
  @media screen and (max-width: 711px) {
    margin: 0;
    flex: 0 0 180px;
  }
`
const Bar = styled.div`
  display: inline-block;
  height: 20px;
  width: 20px;
  margin-right: 5px;
  margin-left: 5px;
  background-color: var(--coffee-color);
  @media screen and (max-width: 711px) {
    margin: 0;
  }
`

const Stats = styled.div`
  flex: 1 1 auto;
  padding-left: 10px;
  font-family: var(--font-sans-serif);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 12px;

  .value {
    font-size: 15px;

    font-weight: 700;
    display: inline-block;
    width: 60px;
    text-align: right;
    margin-right: 5px;
  }
`
const Icon = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 700;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  img {
    min-width: unset;
    width: 30px;
  }
  @media screen and (max-width: 711px) {
    img {
      display: none;
    }
    flex: 0 0 0;
  }
`
const Label = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 700;
  flex: 0 0 20%;
  display: flex;
  align-items: center;
  flex: 0 0 120px;
  @media screen and (max-width: 711px) {
    flex: 0 0 100%;
  }
`

const FlowColumnsRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* flex-direction: column; */

  width: 100%;

  margin-bottom: 60px;
  @media screen and (max-width: 711px) {
    width: calc(100vw - 40px);
  }
`
